<template>
	<order-detail type="retail_order_detail" :order-number="orderNumber"></order-detail>
</template>

<script>
	import orderDetail from './order_detail.vue'
	
	export default {
		name: 'return_detail',
		
		components: {
            orderDetail
		},
		
		props: {
            orderNumber: String
		}
	}
</script>